import { Tag } from 'antd';
import type { User } from 'types/user';
import { mockUserStats } from 'mock/user-detail.mock';

const StatItem = ({ label, value, valueClass }: { label: string; value: string; valueClass?: string }) => (
    <div className="text-center px-4">
        <p className={`text-lg font-bold m-0 ${valueClass || ''}`}>{value}</p>
        <p className="text-xs text-gray-500 dark:text-gray-400 m-0 mt-0.5">{label}</p>
    </div>
);

const UserHeaderCard = ({ user }: { user: User }) => {
    const initials = user.name?.charAt(0).toUpperCase() || 'U';
    const accountLabel = user.accountType === 'vip' ? 'VIP' : user.accountType === 'pre' ? 'Premium' : 'Standard';

    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl p-6 space-y-5">
            <div className="flex items-center gap-5">
                <div className="w-16 h-16 rounded-full flex items-center justify-center shrink-0 bg-blue-100 dark:bg-gray-600">
                    {user.avatar_url ? (
                        <img src={user.avatar_url} alt={user.name} className="w-full h-full rounded-full object-cover" />
                    ) : (
                        <span className="text-2xl font-semibold text-blue-600 dark:text-gray-300">{initials}</span>
                    )}
                </div>

                <div className="flex-1 min-w-0">
                    <h3 className="text-lg font-semibold m-0 mb-1">{user.name}</h3>
                    <p className="text-sm text-gray-500 dark:text-gray-400 m-0 mb-2">
                        ID: {user.id} · Tạo ngày {user.createAt}
                    </p>
                    <div className="flex items-center gap-2 flex-wrap">
                        <Tag color={user.isActive ? 'green' : 'default'}>
                            {user.isActive ? 'Hoạt động' : 'Không hoạt động'}
                        </Tag>
                        <Tag color={user.KYC ? 'blue' : 'warning'}>
                            KYC {user.KYC ? 'đã xác minh' : 'chưa xác minh'}
                        </Tag>
                        <Tag color="purple">{accountLabel}</Tag>
                    </div>
                </div>
            </div>

            <div className="border-t border-gray-100 dark:border-gray-700 pt-4 flex items-center flex-wrap gap-y-3 divide-x divide-gray-200 dark:divide-gray-700">
                <StatItem label="Số dư" value={mockUserStats.balance} />
                <StatItem label="Tổng giao dịch" value={String(mockUserStats.totalTrades)} />
                <StatItem label="Lệnh đang mở" value={String(mockUserStats.openOrders)} />
                <StatItem label="Tổng nạp" value={mockUserStats.deposited} />
                <StatItem label="Tổng rút" value={mockUserStats.withdrawn} />
                <StatItem label="P&L" value={mockUserStats.pnl} valueClass="text-green-600 dark:text-green-400" />
            </div>
        </div>
    );
};

export default UserHeaderCard;
